import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'suiXin-home',
    component: () => import(/* webpackChunkName: "about" */ '../views/suiXin-home.vue')
  },
  {
    path: '/introduction',
    name: 'introduction',
    component: () => import(/* webpackChunkName: "about" */ '../views/aboutUs.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
